import { service } from '../index.js'

// 轮播图管理
export const banner = {
  // 列表（后台）
  list: ({ params = {} } = {}) => {
    return service.get('/banner/admin/list', { params })
  },

  // 添加
  add: (data) => {
    return service.post('/banner/admin/save', data)
  },

  // 更新
  update: (data) => {
    return service.post('/banner/admin/save', data)
  },

  // 切换状态（只更新status）
  toggleStatus: (data) => {
    return service.post('/banner/admin/toggle-status', data)
  },

  // 删除
  delete: (params) => {
    return service.post('/banner/admin/delete', params)
  }
} 

// 系统配置
export const config = {
  // 获取配置
  get: () => {
    return service.get('/config/get')
  },
  
  // 更新配置
  update: (data) => {
    return service.post('/config/update', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/banner.js